import React, { useState, useEffect } from "react";
import { MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLang } from "@/context/LanguageContext";
import { analyticsAllowed, setConsent } from "@/lib/consent";

// Google Maps iframe loads ONLY after cookie consent (GDPR). Before that, a placeholder.
export const ConsentMap = ({ src, title, className, testid = "contact-map" }) => {
  const { t } = useLang();
  const c = t.cookies;
  const [allowed, setAllowed] = useState(analyticsAllowed());

  useEffect(() => {
    const onChange = () => setAllowed(analyticsAllowed());
    window.addEventListener("cfm-consent-changed", onChange);
    return () => window.removeEventListener("cfm-consent-changed", onChange);
  }, []);

  if (!allowed) {
    return (
      <div className={`grid place-items-center bg-stone-alt/60 ${className || ""}`} data-testid={`${testid}-consent`}>
        <div className="text-center px-6 py-8">
          <MapPin className="h-8 w-8 text-brand mx-auto mb-3" />
          <p className="text-sm text-brand-ink/70 max-w-[240px]">{c.map_blocked}</p>
          <Button onClick={() => setConsent("accepted")} className="mt-3 rounded-full bg-brand hover:bg-brand-hover text-brand-cream font-bold h-9 text-sm" data-testid={`${testid}-accept`}>
            {c.map_accept}
          </Button>
        </div>
      </div>
    );
  }
  return <iframe title={title} src={src} className={`w-full h-full ${className || ""}`} style={{ border: 0 }} loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-testid={testid} />;
};
